<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card dark>
          <!--<v-progress-linear height="60" :value="total" class="my-0"></v-progress-linear>-->
          <v-card-text class="px-0 text-xs-center background" :style="{ background: 'linear-gradient(90deg, #3775D2 '+total+'%, #34516d '+total+'%)' }">
            <span class="title">
              <!--<router-link :to="{ name: 'setWeight'}">-->
              <!--{{currentState}}/{{limit}}ml-->
              <!--<v-icon>edit</v-icon>-->
              <!--</router-link>-->
            <v-btn class="title" outline @click="goToSetWeight" flat>
              {{currentState}}/{{limit}}ml
            </v-btn>
            </span>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'totalBar',
    props: ['drunkHistory', 'limit'],
    data() {
      return {}
    },
    computed: {
      currentState() {
        let drunk = 0;
        // console.log("s", this.drunkHistory)

        // this.drunkHistory.then((value) => {
        this.drunkHistory.forEach((drink) => {
          if (drink.active) {
            drunk += parseInt(drink.size)
          }
        })
        // })


        return drunk
      },
      total() {
        return (this.currentState / this.limit) * 100;
      }
    },
    methods: {
      goToSetWeight() {
        this.$router.push({name: 'setWeight'});

      }
    }
  }
</script>

<style scoped>
  a {
    color: white;
    border: none;
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/otherComponents/totalBar.vue